export default "__VITE_ASSET__BUb6R29g__"